import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Skeleton } from 'antd';

import { Text, Title } from '@/components/Typography';
import type { BeraResultInformations } from '../types';
import { RPNTopic, Score, Topic } from './styles';

interface ScoresProps {
	isLoading: boolean;
	data: Pick<BeraResultInformations, 'overall_score' | 'weighted_rsi' | 'total_time' | 'gns'>;
}

export function Scores({ isLoading, data }: Readonly<ScoresProps>) {
	function isGNS(): 'high' | 'low' {
		if (data?.gns) {
			return 'low';
		}

		return 'high';
	}

	function scoreDanger(): 'high' | 'medium' | 'low' {
		if (data?.overall_score > 45) {
			return 'high';
		}

		if (data?.overall_score > 15) {
			return 'medium';
		}

		return 'low';
	}

	return (
		<Col span={8}>
			<Row>
				<Col span={24}>
					<Title level={5}>Results</Title>
				</Col>
			</Row>
			{isLoading ? (
				<Skeleton active />
			) : (
				<Row style={{ marginTop: '0.5rem' }}>
					<Col span={24}>
						<Row justify="center">
							<Col span={24}>
								<Topic>{I18n.get('Total evaluated time')}</Topic>
							</Col>
							<Col span={24}>
								<Text>
									{data?.total_time.split(' ')[0]} {I18n.get(data?.total_time.split(' ')[1])}
								</Text>
							</Col>
						</Row>
						<Row justify="center" style={{ marginTop: '0.5rem' }} gutter={[16, 8]}>
							<Col span={12}>
								<Row justify="center">
									<Col span={24}>
										<RPNTopic>{I18n.get('Total B.E.R.A.')}</RPNTopic>
									</Col>
									<Col span={24} style={{ marginTop: '1.25rem' }}>
										<Score $danger={scoreDanger()}>{Math.round(data?.overall_score ?? 0)}</Score>
									</Col>
								</Row>
							</Col>
							<Col span={12}>
								<Row justify="center">
									<Col span={24}>
										<RPNTopic style={{ textAlign: 'center' }}>{I18n.get('ENS')}</RPNTopic>
									</Col>
									<Col span={24} style={{ marginTop: '1.25rem' }}>
										<Score $danger={isGNS()}>{I18n.get(data?.gns ? 'Yes' : 'No')}</Score>
									</Col>
								</Row>
							</Col>
						</Row>
					</Col>
				</Row>
			)}
		</Col>
	);
}
